module.exports = require("winston");


//////////////////
// WEBPACK FOOTER
// external "winston"
// module id = 113
// module chunks = 0 1 2